import { hsaPdpWidgetPlacementSchema } from "@redotech/redo-conversion-settings-common/hsa-settings";
import * as z from "zod";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.null(),
  output: z.object({
    pdpWidgetPlacement: hsaPdpWidgetPlacementSchema.optional(),
  }),
};
